<div>
  <app-cpqscreen *ngFor="let screen of CurrentCPQPage.Screens" [CurrentScreen]="screen" (ChangeEmitter)="OnScreenChange($event)" (InvalidEmitter)="OnInvalidEmitter($event)">

  </app-cpqscreen>
</div>
